import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mwHoursToTimeDuration',
})
export class MwHoursToTimeDurationPipe implements PipeTransform {
  transform(hours: number, useDecimalFormat: boolean = false): string {
    if (useDecimalFormat) {
      return (hours || 0).toFixed(2).toString();
    }

    const isNegative = hours < 0;
    hours = Math.abs(hours);

    const hoursPart = Math.floor(hours);
    const minutesPart = Math.round((hours * 60) % 60);

    const hoursPartString =
      hoursPart < 10 ? `${hoursPart}` : hoursPart.toString();
    const minutesPartString =
      minutesPart < 10 ? `0${minutesPart}` : minutesPart.toString();

    return `${isNegative ? '-' : ''}${hoursPartString}:${minutesPartString}`;
  }
}
